/**
 * colorUtility mixin
 * Metodi puri di formattazione numeri, gestione colori e lookup contenitori.
 * Richiede che il componente esponga: contenitori_coltivazione (Array)
 */
export default {
  methods: {
    formatNumber(value) {
      if (value === null || value === undefined || Number.isNaN(Number(value))) {
        return "-";
      }
      return Number(value).toLocaleString("it-IT", { maximumFractionDigits: 2 });
    },

    normalizeHexColor(value) {
      const raw = String(value || "").trim().toUpperCase();
      const match = raw.match(/^#?([0-9A-F]{6})([0-9A-F]{2})?$/);
      if (!match) return null;
      return `#${match[1]}`;
    },

    getPaletteNameByHex(hex) {
      const palette = {
        "#F44336": "Rosso", "#E91E63": "Rosa", "#9C27B0": "Viola",
        "#673AB7": "Viola scuro", "#3F51B5": "Indaco", "#2196F3": "Blu",
        "#03A9F4": "Azzurro", "#00BCD4": "Ciano", "#009688": "Turchese",
        "#4CAF50": "Verde", "#8BC34A": "Verde chiaro", "#CDDC39": "Lime",
        "#FFEB3B": "Giallo", "#FFC107": "Ambra", "#FF9800": "Arancione",
        "#FF5722": "Arancione scuro", "#E2725B": "Terracotta", "#795548": "Marrone",
        "#9E9E9E": "Grigio", "#8A7F80": "Grigio tortora", "#607D8B": "Grigio blu",
        "#FFFFFF": "Bianco", "#000000": "Nero",
        "#FFCDD2": "Rosso 100", "#E57373": "Rosso 300", "#D32F2F": "Rosso 700",
        "#F8BBD0": "Rosa 100", "#F06292": "Rosa 300", "#C2185B": "Rosa 700",
        "#E1BEE7": "Viola 100", "#BA68C8": "Viola 300", "#7B1FA2": "Viola 700",
        "#BBDEFB": "Blu 100", "#64B5F6": "Blu 300", "#1976D2": "Blu 700",
        "#B3E5FC": "Azzurro 100", "#4FC3F7": "Azzurro 300", "#0288D1": "Azzurro 700",
        "#B2DFDB": "Turchese 100", "#4DB6AC": "Turchese 300", "#00796B": "Turchese 700",
        "#C8E6C9": "Verde 100", "#81C784": "Verde 300", "#388E3C": "Verde 700",
        "#FFF9C4": "Giallo 100", "#FFF176": "Giallo 300", "#FBC02D": "Giallo 700",
        "#FFE0B2": "Arancione 100", "#FFB74D": "Arancione 300", "#F57C00": "Arancione 700",
        "#A1887F": "Marrone 300", "#5D4037": "Marrone 700",
      };
      return palette[String(hex || "").toUpperCase()] || null;
    },

    parseColorEntry(entry) {
      const raw = String(entry || "").trim();
      if (!raw) return null;

      const chunks = raw.split("|");
      if (chunks.length >= 2) {
        const name = chunks[0].trim();
        const hex = this.normalizeHexColor(chunks[chunks.length - 1]);
        if (hex) {
          return { value: hex, label: name || this.getPaletteNameByHex(hex) || "Colore", hex };
        }
      }

      const hex = this.normalizeHexColor(raw);
      if (hex) {
        return { value: hex, label: this.getPaletteNameByHex(hex) || "Colore", hex };
      }

      return { value: raw, label: raw, hex: null };
    },

    swatchStyle(hex) {
      return {
        display: "inline-block",
        width: "14px",
        height: "14px",
        borderRadius: "50%",
        border: "1px solid rgba(0,0,0,.2)",
        backgroundColor: hex || "transparent",
      };
    },

    labelColoreContenitore(value) {
      if (!value) return "Non specificato";
      const parsed = this.parseColorEntry(value);
      return parsed ? parsed.label : String(value);
    },

    nomeContenitore(idContenitore) {
      const contenitore = this.contenitori_coltivazione.find(
        (item) => item.id === idContenitore
      );
      if (!contenitore) return `ID ${idContenitore}`;
      return `${contenitore.tipo} (Ø ${this.formatNumber(contenitore.diametro)})`;
    },

    diametroContenitore(idContenitore) {
      const contenitore = this.contenitori_coltivazione.find(
        (item) => item.id === idContenitore
      );
      return contenitore ? contenitore.diametro : null;
    },
  },
};
